<template>
  <div
    v-if="
      selectedParameter.param_data && selectedParameter.param_data.risk_alert
    "
    class="space-y-6"
  >
    <p class="text-sm font-bold text-ontick-red-500">
      Atenção, identificamos que no parâmetro escolhido não existe limite de
      perda definido. Caso não esteja certo desta ação, verifique novamente seus
      parâmetros.
    </p>
    <div class="flex items-center space-x-4">
      <input
        type="checkbox"
        id="confirmation"
        class="h-4 w-4 appearance-none rounded border-2 border-ontick-blue-600 bg-transparent text-ontick-blue-600 ring-ontick-red-600 dark:border-gray-300"
        v-model="confirmed"
        @change="$emit('confirmation', confirmed)"
      />
      <label
        for="confirmation"
        class="text-sm font-bold text-ontick-carbon-900 dark:text-gray-300"
      >
        Confirmo que estou usando uma estratégia sem limite de perda
      </label>
    </div>
  </div>
</template>

<script>
import ontickCheckboxComponent from "../../../../../../shared/components/basic/ontick-checkbox.component.vue";

export default {
  components: { ontickCheckboxComponent },
  props: {
    selectedParameter: {
      type: Object,
    },
  },
  data() {
    return {
      confirmed: false,
    };
  },
};
</script>

<style></style>
